import React, { Suspense } from "react"
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom"

import Dashboard from "./pages/Dashboard"
import Login from "./pages/Login"
import ClientChat from "./pages/ClientChat"
import { useAuth } from "hooks/auth"
import ChangePassword from "pages/Login/ChangePassword"
import NotFound from "pages/NotFound"
import TrialAccount from "pages/TrialAccount"
import LdapAuth from "pages/LdapAuth"
import Debug from "pages/Debug"
import InstagramIntegration from "pages/InstagramIntegration"
import { routerBaseSubpath } from "utils/dom"

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = useAuth()

  return (
    <Route
      {...rest}
      render={(props) =>
        user ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  )
}

const Routes = () => (
  <Suspense fallback={null}>
    <BrowserRouter basename={routerBaseSubpath()}>
      <Switch>
        <Route path="/debug" component={Debug} />
        <Route path="/instagram-integration" component={InstagramIntegration} />
        <Route path="/client/chat/:token" component={ClientChat} exact />
        <Route path="/trialaccount" component={TrialAccount} />
        <PrivateRoute path="/dashboard" component={Dashboard} />
        <Route path="/notfound" component={NotFound} />
        <Route path="/ldapauth" component={LdapAuth} />
        <Route path="/changepassword" component={ChangePassword} />
        <Route path="/" component={Login} />
      </Switch>
    </BrowserRouter>
  </Suspense>
)

export default Routes
